import { apiDelete, apiGet } from "./apiClient";

async function getCollection(path, errorMessage) {
  const res = await apiGet(path);
  if (!res.ok) return { ok: false, error: res.error ?? errorMessage, items: [] };
  return { ok: true, items: Array.isArray(res.data) ? res.data : [] };
}

export function fetchDepartmentsList() {
  return getCollection("/api/Departments", "Failed to load departments");
}

export function deleteDepartment(id) {
  return apiDelete(`/api/Departments/${id}`);
}

export function fetchDesignationsList() {
  return getCollection("/api/Designations", "Failed to load designations");
}

export function deleteDesignation(id) {
  return apiDelete(`/api/Designations/${id}`);
}

export function fetchEmployeesList() {
  return getCollection("/api/Employees", "Failed to load employees");
}

export function deleteEmployee(id) {
  return apiDelete(`/api/Employees/${id}`);
}

export function fetchNotificationsList() {
  return getCollection("/api/Notifications", "Failed to load notifications");
}

export function deleteNotification(id) {
  return apiDelete(`/api/Notifications/${id}`);
}
